import React from "react";
import { useTheme } from "../../../hooks";
import { GenericModal } from "../../modal";
const PopoverFooter = ({ children, styles = {}, ...rest }) => {
    const { Theme } = useTheme();
    const StylesOverride = { ...Theme.popover.footer, ...styles };
    return (React.createElement(GenericModal.Footer, { styles: StylesOverride, ...rest }, children));
};
PopoverFooter.displayName = "ModalFooter";
export default PopoverFooter;
//# sourceMappingURL=PopoverFooter.js.map